import BannerSlider from '../modules/components/_banner';
import Header from '../modules/components/_header';
import CardCarousel from '../modules/components/_card-carousel';
import HomeSwiper from '../modules/home.swiper';
import GridSwiper from '../modules/components/_grid-swiper';
import TenantSwiper from '../modules/components/_tenant-swiper';
import BlogSwiper from '../modules/components/_blog-swiper';
import FerryBannerSlider from '../modules/components/_ferry-banner';
import SccTerminalScrollbar from '../modules/components/_scc-terminal-scrollbar';
import FerrySingleBanner from '../modules/components/_ferry-single-banner';
import AnnouncementSwiper from '../modules/announcement-swiper';
import '../modules/components/_portfolio-tag';
// import '../modules/components/_smooth-scroll';
import TenantDetail from '../modules/components/_tenant-detail';
import TerminalMap from '../modules/terminal';
import Map from '../modules/map';
import TerminalMapRoutes from '../modules/termina-routes';



const Components = {
  init() {
    BannerSlider.init();
    Header.init();
    CardCarousel.init();
    HomeSwiper.init();
    GridSwiper.init();
    TenantSwiper.init();
    BlogSwiper.init();
    FerryBannerSlider.init();
    SccTerminalScrollbar.init();
    FerrySingleBanner.init();
    AnnouncementSwiper.init();
    TenantDetail.init();
    TerminalMap.init();
    Map.init();
    TerminalMapRoutes.init();
    
  },
  finalize() {},
};
export default Components;



// WEBPACK FOOTER //
// ./scripts/autoload/_components.js